import { Component, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { Store } from '@ngxs/store';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { Observable, Subject, takeUntil } from 'rxjs';
import { LoadingState } from './store/loading/loading.state';
import { TokenRefreshManagerService } from './core/services/token-refresh-manager/token-refresh-manager.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, NgxSpinnerModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnDestroy {
  private destroy: Subject<boolean> = new Subject<boolean>();
  showLoading$: Observable<boolean> = new Observable();
  getLoadingText$: Observable<string> = new Observable();
  loadingText: string = '';

  constructor(
    private store: Store,
    private ngxSpinnerService: NgxSpinnerService,
    private tokenRefreshManager: TokenRefreshManagerService
  ) {
    this.showLoading$ = this.store.select(LoadingState.showLoading);
    this.getLoadingText$ = this.store.select(LoadingState.getTextLoading);
    this.subscribeState();

    // TokenRefreshManagerService ahora maneja también la sincronización entre pestañas
  }

  subscribeState() {
    this.showLoading$.pipe(takeUntil(this.destroy)).subscribe(show => {
      show ? this.ngxSpinnerService.show() : this.ngxSpinnerService.hide();
    });

    this.getLoadingText$.pipe(takeUntil(this.destroy)).subscribe(text => {
      if (text) {
        this.loadingText = text;
      } else {
        this.loadingText = '';
      }
    });
  }

  ngOnDestroy() {
    this.destroy.next(true);
    this.destroy.unsubscribe();
  }
}
